import { SwapOutlined } from '@ant-design/icons';
import { Space, Popover, DatePicker, Button } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, { Fragment, ReactElement, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FrontDeskAction } from '../../../shared/constants/crmConstants';
import { fetchOutPatientDetails, frontDeskAction } from '../../../store/actions/outPatientAction';
import { ReactComponent as CloseIcon } from '../../../assets/images/svg/i_close.svg';
import { ReactComponent as RoundTickIcon } from '../../../assets/images/svg/i_round_tick.svg';

const FrontDeskActions = ({ text, record, isUpdated }: any): ReactElement => {
  const [actionState, setActionState] = useState({
    requestId: 0,
    rescheduleDate: '',
    statusId: 0,
    nextStatus: '',
    remarks: '',
    isRescheduleOpen: false,
    isCancelOpen: false,
  });
  const dispatch = useDispatch();

  const onChange = (rescheduleDate: any, selectedRecord: any, nextStatus: any): void => {
    const { id, statusID } = selectedRecord;
    setActionState({
      ...actionState,
      rescheduleDate,
      requestId: id,
      statusId: statusID,
      nextStatus,
    });
  };

  const reschedule = (): any => {
    const { requestId, rescheduleDate, statusId, nextStatus } = actionState;
    dispatch(frontDeskAction({
      requestId,
      rescheduleDate,
      statusId,
      nextStatus,
      getData,
    }));
  };

  const getData = (response: any): void => {
    if (response && response.isSuccess) {
      if (isUpdated) { isUpdated(true); }
      dispatch(fetchOutPatientDetails({ pageIndex: 1, pageRange: 10, getData }));
      setActionState({
        ...actionState,
        isRescheduleOpen: false,
        isCancelOpen: false,
      });
    }
  };

  const setDeleteData = (remarks: any, selectedRecord: any, nextStatus: any): void => {
    const { id, statusID } = selectedRecord;
    setActionState({
      ...actionState,
      remarks,
      requestId: id,
      statusId: statusID,
      nextStatus,
    });
  };

  const deleteRecord = (): void => {
    const { requestId, statusId, nextStatus, remarks } = actionState;
    dispatch(frontDeskAction({
      requestId,
      statusId,
      remarks,
      nextStatus,
      getData,
    }));
  };

  return <Space size="large">
    {
      text && text.length > 0 && text.map((item: any, index: any): any => {
        const { action } = item;
        return (
          <a key={index}>{
            action === FrontDeskAction.CONFIRM ?
              <RoundTickIcon className="fill-success" />
              :
              action === FrontDeskAction.RESCHEDULE ?
                <Popover placement="left" visible={actionState.isRescheduleOpen} title={'Reschedule Date'} content={
                  <Fragment>
                    <DatePicker onChange={(date: any, dateString: any): void => onChange(dateString, record, 'Rescheduled')} />
                    <Button type="primary" onClick={(): void => reschedule()}>Submit</Button>
                  </Fragment>
                } trigger="click">
                  <SwapOutlined style={{ color: 'yellow' }} onClick={(): void => {
                    setActionState({ ...actionState, isRescheduleOpen: !actionState.isRescheduleOpen, isCancelOpen: false });
                  }} />
                </Popover>
                :
                action === FrontDeskAction.CANCEL ?
                  <Popover placement="left" title={'Remarks'} visible={actionState.isCancelOpen} content={<Fragment><TextArea
                    onChange={(e: any): void => setDeleteData(e.target.value, record, FrontDeskAction.CANCEL)} />
                    <Button type="primary" onClick={(): void => deleteRecord()}>Delete</Button>
                  </Fragment>} trigger="click">
                    <span className="error-text"><CloseIcon className="fill-close v-align-middle" onClick={(): void => {
                      setActionState({ ...actionState, isCancelOpen: !actionState.isCancelOpen, isRescheduleOpen: false });
                    }} /></span>
                  </Popover> :
                  action === FrontDeskAction.ATTENDED || action === FrontDeskAction.NOT_ATTENDED ?
                    <a onClick={(): any =>
                      dispatch(frontDeskAction({ requestId: record?.id, nextStatus: action, statusId: record?.statusID, getData }))
                    }>{action}</a> : null}
          </a>
        );
      })
    }
  </Space>;
};

export default FrontDeskActions;
